export default {
  v: '5.3.4',
  fr: 60,
  ip: 0,
  op: 125,
  w: 150,
  h: 150,
  nm: 'PieChart_Preview',
  ddd: 0,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Splash',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 32, ix: 10 },
            p: { a: 0, k: [75.019, 74.993, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 2',
              np: 1,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 40, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 4',
              np: 1,
              cix: 2,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 80, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 5',
              np: 1,
              cix: 2,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 120, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 6',
              np: 1,
              cix: 2,
              ix: 4,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 160, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 7',
              np: 1,
              cix: 2,
              ix: 5,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 200, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 8',
              np: 1,
              cix: 2,
              ix: 6,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 240, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 9',
              np: 1,
              cix: 2,
              ix: 7,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 280, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 10',
              np: 1,
              cix: 2,
              ix: 8,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 320, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 1',
              np: 1,
              cix: 2,
              ix: 9,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.19], y: [1] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p19_1_0p167_0p167'],
                    t: 45,
                    s: [50.66],
                    e: [0]
                  },
                  { t: 66 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.19], y: [1] },
                    o: { x: [0.485], y: [0] },
                    n: ['0p19_1_0p485_0'],
                    t: 45,
                    s: [56.2],
                    e: [0.01]
                  },
                  { t: 66 }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 10,
              nm: 'Trim Paths 1',
              mn: 'ADBE Vector Filter - Trim',
              hd: false
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.59], y: [0] },
                    n: ['0p833_0p833_0p59_0'],
                    t: 43,
                    s: [0],
                    e: [4.9]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 46,
                    s: [4.9],
                    e: [4.9]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 66,
                    s: [4.9],
                    e: [0]
                  },
                  { t: 70 }
                ],
                ix: 5
              },
              lc: 2,
              lj: 2,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            }
          ],
          ip: 43,
          op: 71,
          st: 16,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Chart 2',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [74.974, 75.002, 0], ix: 2 },
            a: { a: 0, k: [70.9, 77.094, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                  o: { x: [1, 1, 1], y: [0, 0, 0] },
                  n: ['0p667_1_1_0', '0p667_1_1_0', '0p667_1_1_0'],
                  t: 6,
                  s: [100, 100, 100],
                  e: [0, 0, 100]
                },
                { t: 48 }
              ],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [19.11, 0], [0, 19.111], [-19.111, 0], [-10.2, -10.796]],
                      o: [
                        [0, 0],
                        [0, 19.111],
                        [-19.111, 0],
                        [0, -19.111],
                        [0, 0],
                        [10.373, 10.979]
                      ],
                      v: [
                        [29.122, 5.85],
                        [29.122, 5.46],
                        [-5.46, 39.912],
                        [-39.911, 5.46],
                        [-5.46, -29.122],
                        [19.514, -18.693]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [76.352, 71.243], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 14,
          op: 46,
          st: -9,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Chart',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [74.974, 75.002, 0], ix: 2 },
            a: { a: 0, k: [70.9, 77.094, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
                  o: { x: [1, 1, 1], y: [0, 0, 0] },
                  n: ['0p667_1_1_0', '0p667_1_1_0', '0p667_1_1_0'],
                  t: 6,
                  s: [100, 100, 100],
                  e: [0, 0, 100]
                },
                { t: 48 }
              ],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.667, y: 1 },
                        o: { x: 0.82, y: 0 },
                        n: '0p667_1_0p82_0',
                        t: 1,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, -19.11], [0, 0]],
                            o: [[0, 0], [19.111, 0], [0, 0], [0, 0]],
                            v: [
                              [5.461, -5.071],
                              [5.461, -39.912],
                              [39.911, -5.461],
                              [39.911, -5.071]
                            ],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, -19.11], [0, 0]],
                            o: [[0, 0], [19.111, 0], [0, 0], [0, 0]],
                            v: [
                              [-5.373, 5.929],
                              [-5.373, -28.912],
                              [29.078, 5.539],
                              [29.078, 5.929]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 14 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ind: 1,
                  ty: 'sh',
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [19.11, 0], [0, 19.111], [-19.111, 0], [0, 0]],
                      o: [[0, 0], [0, 19.111], [-19.111, 0], [0, -19.111], [0, 0], [0, 0]],
                      v: [
                        [29.122, 5.85],
                        [29.122, 5.46],
                        [-5.46, 39.912],
                        [-39.911, 5.46],
                        [-5.46, -29.122],
                        [-5.46, 5.85]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [76.352, 71.243], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 4,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 14,
          st: -9,
          bm: 0
        }
      ]
    },
    {
      id: 'comp_1',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Splash',
          parent: 3,
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 44.254, ix: 10 },
            p: { a: 0, k: [100.375, 45.958, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: -40, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 3',
              np: 1,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 2',
              np: 1,
              cix: 2,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0]],
                      o: [[0, 0], [0, 0]],
                      v: [[0.011, -30.399], [0.011, -1.649]],
                      c: false
                    },
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [0, 0], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 40, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Shape 1',
              np: 1,
              cix: 2,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.19], y: [1] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p19_1_0p167_0p167'],
                    t: 25,
                    s: [50.66],
                    e: [0]
                  },
                  { t: 46 }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  {
                    i: { x: [0.19], y: [1] },
                    o: { x: [0.485], y: [0] },
                    n: ['0p19_1_0p485_0'],
                    t: 25,
                    s: [56.2],
                    e: [0.01]
                  },
                  { t: 46 }
                ],
                ix: 2
              },
              o: { a: 0, k: 0, ix: 3 },
              m: 1,
              ix: 4,
              nm: 'Trim Paths 1',
              mn: 'ADBE Vector Filter - Trim',
              hd: false
            },
            {
              ty: 'st',
              c: { a: 0, k: [0, 0, 0, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.59], y: [0] },
                    n: ['0p833_0p833_0p59_0'],
                    t: 23,
                    s: [0],
                    e: [4.9]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 26,
                    s: [4.9],
                    e: [4.9]
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    n: ['0p833_0p833_0p167_0p167'],
                    t: 46,
                    s: [4.9],
                    e: [0]
                  },
                  { t: 50 }
                ],
                ix: 5
              },
              lc: 2,
              lj: 2,
              nm: 'Stroke 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            }
          ],
          ip: 23,
          op: 51,
          st: -4,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Chart 2',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [74.974, 75.002, 0], ix: 2 },
            a: { a: 0, k: [70.9, 77.094, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0, 0, 0], y: [1, 1, 1] },
                  o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                  n: ['0_1_0p333_0', '0_1_0p333_0', '0_1_0p333_0'],
                  t: 1,
                  s: [0, 0, 100],
                  e: [100, 100, 100]
                },
                { t: 35 }
              ],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.18, y: 1 },
                        o: { x: 0.333, y: 0 },
                        n: '0p18_1_0p333_0',
                        t: 17,
                        s: [
                          {
                            i: [[0, 0], [0, 0], [0, -19.11], [0, 0]],
                            o: [[0, 0], [19.111, 0], [0, 0], [0, 0]],
                            v: [[-5.32, 5.712], [-5.32, -29.129], [29.131, 5.322], [29.131, 5.712]],
                            c: true
                          }
                        ],
                        e: [
                          {
                            i: [[0, 0], [0, 0], [0, -19.11], [0, 0]],
                            o: [[0, 0], [19.111, 0], [0, 0], [0, 0]],
                            v: [
                              [5.461, -5.071],
                              [5.461, -39.912],
                              [39.911, -5.461],
                              [39.911, -5.071]
                            ],
                            c: true
                          }
                        ]
                      },
                      { t: 37 }
                    ],
                    ix: 2
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ind: 1,
                  ty: 'sh',
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [19.11, 0], [0, 19.111], [-19.111, 0], [0, 0]],
                      o: [[0, 0], [0, 19.111], [-19.111, 0], [0, -19.111], [0, 0], [0, 0]],
                      v: [
                        [29.122, 5.85],
                        [29.122, 5.46],
                        [-5.46, 39.912],
                        [-39.911, 5.46],
                        [-5.46, -29.122],
                        [-5.46, 5.85]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [76.352, 71.243], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 4,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 17,
          op: 52,
          st: -9,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Chart',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [74.974, 75.002, 0], ix: 2 },
            a: { a: 0, k: [70.9, 77.094, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0, 0, 0], y: [1, 1, 1] },
                  o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
                  n: ['0_1_0p333_0', '0_1_0p333_0', '0_1_0p333_0'],
                  t: 1,
                  s: [0, 0, 100],
                  e: [100, 100, 100]
                },
                { t: 35 }
              ],
              ix: 6
            }
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [[0, 0], [0, 0], [19.11, 0], [0, 19.111], [-19.111, 0], [-10.2, -10.796]],
                      o: [
                        [0, 0],
                        [0, 19.111],
                        [-19.111, 0],
                        [0, -19.111],
                        [0, 0],
                        [10.373, 10.979]
                      ],
                      v: [
                        [29.122, 5.85],
                        [29.122, 5.46],
                        [-5.46, 39.912],
                        [-39.911, 5.46],
                        [-5.46, -29.122],
                        [19.514, -18.693]
                      ],
                      c: true
                    },
                    ix: 2
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false
                },
                {
                  ty: 'mm',
                  mm: 1,
                  nm: 'Merge Paths 1',
                  mn: 'ADBE Vector Filter - Merge',
                  hd: false
                },
                {
                  ty: 'fl',
                  c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
                  o: { a: 0, k: 100, ix: 5 },
                  r: 1,
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false
                },
                {
                  ty: 'tr',
                  p: { a: 0, k: [76.352, 71.243], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: 'Transformer '
                }
              ],
              nm: 'Group 1',
              np: 3,
              cix: 2,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false
            }
          ],
          ip: 0,
          op: 17,
          st: -9,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: 'PieChart_AnimOff',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [75, 75, 0], ix: 2 },
        a: { a: 0, k: [75, 75, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      w: 150,
      h: 150,
      ip: 52,
      op: 125,
      st: 52,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: 'PieChart_AnimOn',
      refId: 'comp_1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [75, 75, 0], ix: 2 },
        a: { a: 0, k: [75, 75, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      w: 150,
      h: 150,
      ip: 0,
      op: 52,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
